import { Pagination, createTable, Link as LinkMagik, Button } from "@inmagik/magik-ui"
import { useMemo, useState } from "react"
import type { FiltersBase, User } from "../../types"
import dayjs from "dayjs"
import { API_URL, PAGE_SIZE } from "../../constants"
import { Link } from "react-router-dom"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import { Modal, ModalHeader, ModalBody, ModalTitle, ModalFooter } from "react-bootstrap"
import { fetchApi } from "@inmagik/react-crud"
import { useAuth } from "../../auth"

const Table = createTable<User>()

export function TableUtenti({
  utenti,
  setFilters,
  filters,
  count,
  fullCount,
  refetch,
}: {
  utenti: User[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
  refetch: () => void
}) {
  // const [sort, setSort] = useState<string>("")
  const [selectedRows, setSelectedRows] = useState<number[]>([])

  const numPages = useMemo(() => {
    if (!utenti) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [utenti, count])

  const [modalSblockState, setModalSblockActions] = useModalTrigger()
  const { tokens } = useAuth()

  return (
    <>
      <Table
        data={utenti}
        className="w-100 overflow-scroll flex-1"
        orderBy={filters.ordering.replace("-", "")}
        orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
        onOrderChange={(field, direction) => {
          if (field) {
            if (direction === "desc") {
              setFilters({ ...filters, ordering: `-${field}` })
            } else {
              setFilters({ ...filters, ordering: field })
            }
          } else {
            setFilters({ ...filters, ordering: "" })
          }
        }}
      >
        <Table.HeaderConfig sticky />

        <Table.BodyConfig />

        <Table.Selection
          selectionField="id"
          selectedRows={selectedRows}
          onSelectionChange={(rows) => {
            setSelectedRows(rows)
          }}
        />

        <Table.Column
          title="Nome"
          name="full_name"
          sortable
          width="minmax(max-content, 1fr)"
          render={(user) => (
            <Link to={`/utenti/utenti/${user.id}`}>
              <LinkMagik className="text-dark">{user.full_name}</LinkMagik>
            </Link>
          )}
          stickyLeft
          icon="person"
          // TODO badge
        />
        <Table.Column
          title="Email"
          name="email"
          sortable
          width="minmax(max-content, 1fr)"
          render={(user: User) => user.email}
        />
        <Table.Column
          title="Attivo"
          width="minmax(max-content, 1fr)"
          sortable
          name="is_active"
          render={(user) => (user.is_active ? "Si" : "No")}
        />
        <Table.Column
          title="Ultimo accesso"
          name="last_login"
          width="minmax(max-content, 1fr)"
          render={(user) => (user.last_login ? dayjs(user.last_login).format("DD/MM/YYYY HH:mm") : "N/A")}
        />
        <Table.Column
          title="Bloccato"
          name="is_locked"
          width="minmax(max-content, 1fr)"
          sortable
          render={(user) =>
            user.is_locked ? (
              <div>
                <Button
                  size="sm"
                  title="Sblocca"
                  onClick={() => {
                    setModalSblockActions.open({
                      userId: user.id,
                      userName: user.full_name || user.email,
                    })
                  }}
                />
              </div>
            ) : (
              ""
            )
          }
        />
        <Table.Footer.Left>
          Stai visualizzando {count} di {fullCount} utenti
        </Table.Footer.Left>
        <Table.Footer.Center>
          <Pagination
            page={filters.page}
            numPages={numPages}
            onPageChange={(page) => setFilters({ ...filters, page })}
          />
        </Table.Footer.Center>
      </Table>
      <Modal
        show={modalSblockState.isOpen}
        onHide={() => {
          setModalSblockActions.close()
        }}
        centered
        backdrop="static"
      >
        <ModalHeader closeButton>
          <ModalTitle>Sblocca utente</ModalTitle>
        </ModalHeader>
        <ModalBody>Sei sicuro di voler sbloccare l'utente {modalSblockState.value?.userName}?</ModalBody>
        <ModalFooter>
          <Button variant="primary" outline onClick={() => setModalSblockActions.close()} title="Annulla" />

          <Button
            variant="primary"
            onClick={() => {
              // TODO sblocca utente
              return fetchApi(`${API_URL}/admin/users/${modalSblockState.value?.userId}/unlock/`, {
                method: "POST",
                headers: {
                  Authorization: `Bearer ${tokens?.access}`,
                },
              }).then(() => {
                setModalSblockActions.close()
                refetch()
              })
            }}
            title="Sblocca"
          />
        </ModalFooter>
      </Modal>
    </>
  )
}
